export default "/_nuxt/ea1e788436d4e8f9153f1724532b4e29.svg";